export default {"src":"/_next/static/media/etherscan.4f28b82b.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};